/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 *
 * @class APISpec
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class APISpec {
		getAPISpec() {
			if (!this.apiSpec) {
				this.apiSpec = {
					name: 'savedPrompts API',
					events: {
						propagationInfo: {
							namespace: 'savedPrompts',
							callStack: {
								name:'getSavedPrompts'
							},
							info: {
								supportsUndoRedo: true,
								refresh: {
									dataIfQueryChanged: true
								}
							}
						},
						actions: {
							// todo: for now we wire off the new api events mechanism for Prompts API.
							// we need to consider the entire prompts feature in the future if we want to enable events here.
							'save': {
								eventName: 'savedprompts:save',
								getInfo: (args) => {
									return {
										promptValueSpec: args ? args[0] : undefined
									};
								},
								getUndoActions: () => {
									const currentValue = this.widgetModel.get('savedPrompts');
									return [{
										name: 'reset',
										params:[currentValue ? JSON.parse(JSON.stringify(currentValue)) : undefined, true]
									}];
								}
							},
							'reset': {
								eventName: 'savedprompts:reset',
								getInfo: (args) => {
									return {
										promptValueSpec: args ? args[0] : undefined
									};
								},
								getUndoActions: (args) => {
									return [{
										name: 'reset',
										params:[args[0], true]
									}];
								},
								isTriggerEvent: (action, undoActions, returnValue) => {
									return returnValue;
								}
							}
						}
					}

				};
			}
			return this.apiSpec;
		}
	}

	return APISpec;
});
